import { transition } from './common';
const el = document.querySelector('[data-site-main-dimmer]');
const site_main_dimmer_animation = transition({
    el,
    state: 'closed',
});
export const openers = new Set();
export const disableAnimations = 'reduceAnimations' in document.body.dataset;
export function dim(requestor) {
    if (disableAnimations)
        return;
    if (openers.has(requestor))
        return;
    openers.add(requestor);
    site_main_dimmer_animation === null || site_main_dimmer_animation === void 0 ? void 0 : site_main_dimmer_animation.animateTo('open');
}
export function clear(requestor) {
    openers.delete(requestor);
    if (openers.size)
        return;
    site_main_dimmer_animation === null || site_main_dimmer_animation === void 0 ? void 0 : site_main_dimmer_animation.animateTo('closed', {
        force: disableAnimations,
    });
}
